import { Map, Expression } from 'mapbox-gl';
import { mapColorPalette, stateToRegionByName } from "../../../../../constants/Map";

interface RegionViolation {
  epaRegion: string;
  totalHousingUnits: number;
}

interface UpdateRegionStylesProps {
  mapRef: React.RefObject<Map>;
  regionsHousingUnits: RegionViolation[];
  regionsHousingUnitsRef: React.MutableRefObject<RegionViolation[]>;
}

const createRegionColorMapping = (sortedRegions: RegionViolation[]): Record<string, string> => {
  return sortedRegions.reduce((acc, region, index) => {
    if (region?.epaRegion) {
      acc[region.epaRegion] = mapColorPalette[index] || '#ffffff';
    }
    return acc;
  }, {} as Record<string, string>);
};

const createFillColorExpression = (regionToColorMapping: Record<string, string>): Expression => {
  return [
    'match',
    ['get', 'name'],
    ...Object.entries(stateToRegionByName)
      .map(([stateName, { epaRegion }]) => [
        stateName,
        regionToColorMapping[epaRegion] || '#ffffff'
      ])
      .flat(),
    '#ffffff',
  ] as Expression;
};

export const updateRegionStyles = ({
  mapRef,
  regionsHousingUnits,
  regionsHousingUnitsRef,
}: UpdateRegionStylesProps): void => {
  if (!regionsHousingUnits.length || !mapRef.current) {
    return;
  }

  try {
    regionsHousingUnitsRef.current = regionsHousingUnits;
    const regionToColorMapping = createRegionColorMapping(regionsHousingUnits);
    const fillColorExpression = createFillColorExpression(regionToColorMapping);
    if (mapRef.current.getLayer('states')) {
      mapRef.current.setPaintProperty(
        'states',
        'fill-color',
        fillColorExpression
      );
    }
  } catch (error) {
    console.error('Error updating region styles:', error);
  }
};